package com.starparty.app.astro0.celestialobjects

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Colour

internal class Uranus(sun: Sun) :
    Planet(sun) {
    private val DEF_URANUS_COLOR = SP_Colour(170, 255, 200, 255)
    var mJupiter: Jupiter? = null
    var mSaturn: Saturn? = null
    fun setJupiter(j: Jupiter) {
        mJupiter = j
    }

    fun setSaturn(s: Saturn) {
        mSaturn = s
    }

    override fun addPerturbations() {
        super.addPerturbations()
        val Mu = mOEs[M]
        val Mj = mJupiter!!.mOEs[M]
        val Ms = mSaturn!!.mOEs[M]
        mlonEcl = mlonEcl + +0.040 * MathD.sinD(Ms - 2 * Mu + 6)
        mlonEcl = mlonEcl + +0.035 * MathD.sinD(Ms - 3 * Mu + 33)
        mlonEcl = mlonEcl + -0.015 * MathD.sinD(Mj - Mu + 20)
    }

    init {
        rgbColour = DEF_URANUS_COLOR
        name = "Uranus"
        abbrevName = "\u2645"
        setOrbitalElementsData(OE_URANUS)
    }
}